<template>
  <transition name="toast-fade">
    <div v-if="visible" class="custom-success-toast">
      <img v-if="type === 'fail'" src="@/assets/common/NKA/fail.svg" alt="fail" width="20" height="20" />
      <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="10" fill="#22c55e"/>
        <path d="M6 10.5l2.5 2.5 5.5-5.5" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span style="margin-left: 4px;">{{ message }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CustomToast',
  data() {
    return {
      visible: false,
      message: '',
      type: '',
      timer: null
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  },
  methods: {
    show(msg, duration, type) {
      duration = duration || 2000
      this.message = msg
      this.type = type || ''
      this.visible = true
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.visible = false
      }, duration)
    }
  }
}
</script>

<style>
.custom-success-toast {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: inline-flex;
  align-items: center;
  padding: 10px 20px;
  background: #fff;
  border-radius: 20px;
  color: #333;
  font-size: 13px;
  z-index: 9999;
  pointer-events: none;
  max-width: 80vw;
  width: fit-content;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  white-space: normal;
  word-break: break-all;
  font-family: AlibabaPuHuiTi;
}
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.toast-fade-enter,
.toast-fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
.toast-fade-enter-to,
.toast-fade-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>
